import { AuthorizedInstallerApplication } from '@authorizedInstaller/types/authorizedInstallers';
import { IUser } from '@common/types/user';
import { initialFormik } from '@utils/common';
import { FormikProps } from 'formik';
import { createContext } from 'react';

const AuthorizedInstallersContext = createContext<{
    formik: FormikProps<Partial<AuthorizedInstallerApplication>>;
    user?: Omit<IUser, 'full_name'>;
}>({
    formik: initialFormik,
});

export { AuthorizedInstallersContext };
